import React, { Fragment } from "react";
import PropTypes from "prop-types";
import PermanentActiveContent from "./PermanentActiveContent";
import {
  RadioButtonsLabel,
  RadioButtonGroup,
  RadioButtonWrapper,
  RadioButton,
  RadioButtonLabel,
  Check,
  Field,
} from "../styles/form-styles";

const Permanent = ({
  salaryMin,
  salaryMax,
  handleTextInput,
  salaryType,
  handleSalaryType,
  currency,
  errors,
}) => (
  <Fragment>
    <Field radioButtons>
      <RadioButtonsLabel>Salary type:</RadioButtonsLabel>
      <RadioButtonGroup>
        <RadioButtonWrapper>
          <RadioButton
            name="salaryType"
            id="fixed"
            type="radio"
            checked={salaryType === "fixed"}
            onChange={(e) => handleSalaryType(e)}
          />
          <RadioButtonLabel htmlFor="fixed">Fixed</RadioButtonLabel>
          <Check />
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton
            name="salaryType"
            id="range"
            type="radio"
            checked={salaryType === "range"}
            onChange={(e) => handleSalaryType(e)}
          />
          <RadioButtonLabel htmlFor="range">Range</RadioButtonLabel>
          <Check />
        </RadioButtonWrapper>
      </RadioButtonGroup>
    </Field>
    <PermanentActiveContent
      salaryType={salaryType}
      salaryMin={salaryMin}
      salaryMax={salaryMax}
      handleTextInput={handleTextInput}
      errors={errors}
      currency={currency}
    />
  </Fragment>
);

Permanent.propTypes = {
  salaryMin: PropTypes.string,
  salaryMax: PropTypes.string,
  handleTextInput: PropTypes.func.isRequired,
  salaryType: PropTypes.string.isRequired,
  handleSalaryType: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  currency: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    isoCode: PropTypes.string.isRequired,
  }),
};

Permanent.defaultProps = {
  salaryMin: PropTypes.isNull,
  salaryMax: PropTypes.isNull,
  currency: {
    symbol: null,
    currency: null,
  },
};

export default Permanent;
